import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "output"];
  static values = { showIf: String };

  declare readonly hasInputTarget: boolean;
  declare readonly inputTarget: HTMLInputElement;

  declare readonly hasOutputTarget: boolean;
  declare readonly outputTargets: [HTMLInputElement];

  declare showIfValue: string;
  declare readonly hasShowIfValue: boolean;

  declare readonly hasInputTargets: boolean;
  declare readonly inputTargets: [HTMLInputElement];

  connect() {
    this.toggle();
  }

  toggle() {
    const shouldHideInputs = this.shouldHide();

    this.inputTargets.forEach((inputTarget) => {
      const formGroup = inputTarget.closest(".form-group");

      if (shouldHideInputs) {
        formGroup.classList.remove("disabled");
        this.enableOutputs();
      } else {
        formGroup.classList.add("disabled");
        this.disableOutputs();
      }
    });
  }

  enableOutputs() {
    this.outputTargets.forEach((outputTarget) => {
      outputTarget.removeAttribute("disabled");
      if (outputTarget.tagName === "A") {
        outputTarget.style.display = "inline";
      }
    });
  }

  disableOutputs() {
    this.outputTargets.forEach((outputTarget) => {
      if (outputTarget.tagName === "A") {
        outputTarget.style.display = "none";
      } else {
        outputTarget.setAttribute("disabled", "true");
      }
    });
  }

  shouldHide() {
    if (
      this.inputTarget.tagName === "INPUT" ||
      this.inputTarget.tagName === "SELECT"
    ) {
      if (this.inputTarget.type === "checkbox") {
        return !this.inputTarget.checked;
      } else if (this.inputTarget.type === "select-one") {
        return this.inputTarget.value === this.showIfValue;
      } else {
        return false;
      }
    }
  }
}
